import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ForgetPassword from "../Components/Login/ForgetPassword";
// import ForgetPassword from "../Components/Login/ForgetPassword";
import Login from "../Components/Login/Login";
import ResetPassword from "../Components/Login/ResetPassword";
import Signup from "../Components/Login/Signup";
// import ResetPassword from "../Components/Login/ResetPassword";

const MainRoute = () => (
  <Routes>
    <Route exact path="/" element={<Login />} />
    <Route exact path="/sign-up" element={<Signup />} />
    <Route exact path="/forget-password" element={<ForgetPassword />} />
    <Route exact path="/reset-password" element={<ResetPassword />} />
    {/* <Route exact path="/forget-password" element={<ForgetPassword />} /> */}
    {/* <Route exact path="/reset-password" element={<ResetPassword />} /> */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default MainRoute;
